import { StatusLabelTypes } from '@factorialco/deprecated-design-system'
import {
  BankingEntitiesPaymentStatusEnum,
  BankingEntitiesTransactionStatusEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export function statusText(
  status: BankingEntitiesPaymentStatusEnum | BankingEntitiesTransactionStatusEnum
) {
  switch (status) {
    case 'init':
    case 'pending_consent':
      return i18n.t('banking.payments.statuses.pending')
    case 'in_progress':
      return i18n.t('banking.payments.statuses.in_progress')
    case 'rejected':
      return i18n.t('banking.payments.statuses.failed')
    case 'done':
      return i18n.t('banking.payments.statuses.paid')
  }
}

export function statusLabelType(status: BankingEntitiesPaymentStatusEnum): StatusLabelTypes {
  switch (status) {
    case 'pending_consent':
    case 'init':
      return 'neutral'
    case 'in_progress':
      return 'info'
    case 'rejected':
      return 'critical'
    case 'done':
      return 'positive'
    default:
      return status satisfies never
  }
}
